export const defaults = {
  defaultLocale: {
    dateLocale: 'en-gb',
    numberLocale: 'en-gb',
  },
  defaultLanguageCode: 'en-US',
}
